export default "__VITE_ASSET__ArJhDJpo__"